import { Component, OnInit } from '@angular/core';
import { AppTranslateService } from './core/service/app-translate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  public title:string = 'Share Holders';

  constructor(private appTranslateService : AppTranslateService){}

  ngOnInit(){
    let appLanguage = 'sv';
    if(this.appTranslateService.currentLang()){
      appLanguage = this.appTranslateService.currentLang();
    }
    this.appTranslateService.setDefaulfLang(appLanguage);    
  } 

}
